import script from "./MModalDeAlerta.vue?vue&type=script&lang=ts&setup=true"
export * from "./MModalDeAlerta.vue?vue&type=script&lang=ts&setup=true"

import "./MModalDeAlerta.vue?vue&type=style&index=0&id=22324318&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22324318"]])

export default __exports__